import System from 'src/helper/system';
import { useOrderStore } from 'src/hooks/order';
import React, { useState, useEffect } from 'react';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import useReduxState from 'src/hooks/useReduxState';
import { Tooltip } from 'src/component/Global/Tooltip';
import Helper from 'src/helper/Helper';
import Constants from 'src/helper/Constants';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import noncancel from "src/assets/images/icon-non-cancel-black.png";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useSystem } from "src/hooks/system";

const OrderDetailByLineItem = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ order_detail, selected_fields }, { }, { order_download_invoice, toggle_single_selected_fields }] = useOrderStore();
    const [ascDesField, setAscDesField] = useState({});
    const [sortBy, setSortBy] = useState('');
    const [isReorderable] = useReduxState(false, 'setIsReOrderable')
    const [isCancellable] = useReduxState(false, 'setIsCancellable')
    const [expandedRow, setExpandedRow] = useState('')
    const [sortedData, setSortedData] = useState();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { currencyType: { USD }, siteUser: { CORE } , downloadMsg } = Constants
    const [,{ get_quantity_format }] = useSystem();

    const isCoreUser = System.avUserInfoData.currentUser === CORE

    useEffect(() => {
        setSortedData(order_detail?.orderItems)
    }, [order_detail])

    const sortAttributes = (columnName) => {
        let Attributes = [...order_detail?.orderItems]
        let AttributesSorted = []
        if (ascDesField.hasOwnProperty(columnName)) {
            ascDesField[columnName] = ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setAscDesField(ascDesField)
        } else {
            ascDesField[columnName] = 'ASC'
            setAscDesField(ascDesField)
        }
        setSortBy(columnName)
        if (ascDesField[columnName] === 'ASC') {
            if (columnName === 'quantity' || columnName === 'unitPrice' || columnName === 'totalLinePrice' || columnName === 'totalWithTax' || columnName === 'totalShippedQty' || columnName === 'totalRemainingQty') {
                AttributesSorted = Attributes.sort((a, b) => (parseInt(a[columnName]) < parseInt(b[columnName]) ? -1 : 1));
            } else {
                AttributesSorted = Attributes.sort((a, b) => (a[columnName] < b[columnName] ? -1 : 1));
            }
        } else if (ascDesField[columnName] === 'DESC') {
            if (columnName === 'quantity' || columnName === 'unitPrice' || columnName === 'totalLinePrice' || columnName === 'totalWithTax' || columnName === 'totalShippedQty' || columnName === 'totalRemainingQty') {
                AttributesSorted = Attributes.sort((a, b) => (parseInt(a[columnName]) > parseInt(b[columnName]) ? -1 : 1));
            } else {
                AttributesSorted = Attributes.sort((a, b) => (a[columnName] > b[columnName] ? -1 : 1));
            }
        }
        setSortedData(AttributesSorted)
    };

    const getOrderByClass = (columnName) => {
        if (sortBy === columnName && ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    const onToggleSelect = (values) => {
        let selectedField = { ...values }
        toggle_single_selected_fields({ ...selectedField })
    }

    const handleClick = async (shipment) => {
        setExpandedRow(prevExpandedRow => prevExpandedRow === shipment ? null : shipment);
    }

    const renderLegendIcon = (iconPath, message, showIcon) => {
        return (
            showIcon ?
                (
                    <span className="list-text-icon"><img className="img-fluid me-1" alt="Legend Information Icon" src={iconPath} /></span>
                ) :
                (
                    <Tooltip
                        position={'bottom left'}
                        opener={() => (
                            <span className="list-text-icon"><img
                                className="img-fluid me-1" alt="Legend Information Icon"
                                src={iconPath} /></span>
                        )}
                        content={() => (
                            message
                        )}
                    />
                )
        )
    };

    const getStatusOfForFieldActivated = (selectedList) => {
        if (selected_fields && selected_fields[selectedList.uniqueNumber] !== undefined) {
            return selected_fields[selectedList.uniqueNumber];
        }

        return false
    };

    const downloadInvoice = async (invoiceNumber) => {
        const result = await order_download_invoice(invoiceNumber);
        if (result) {
            system_alert_indicator({
                name: 'DownloadOrder',
                message: downloadMsg,
                type: "success"
            })
        }
    }

    return (
        <>
            {__check(['GET_ORDER_DETAIL']).render}
            <div id="tab2" className="tab-pane fade position-relative in active">
                <div className="table-responsive orderdetailbylineitem">
                    {order_detail?.orderItems?.length > 0 && !__check(['GET_ORDER_DETAIL']).status &&
                        <table className="bs5 table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th className=""></th>
                                    <th className="text-nowrap"></th>
                                    {isCoreUser && <th className=""></th>}
                                    <th className="minw100"><span>Line Item <br />Number</span></th>
                                    <th className={
                                        getOrderByClass('manufacturerName')
                                    }
                                        onClick={() => {
                                            sortAttributes('manufacturerName')
                                        }}><span>Manufacturer</span></th>
                                    <th className={
                                        getOrderByClass('manufacturerPartNumber') + ' minw170'
                                    }
                                        onClick={() => {
                                            sortAttributes('manufacturerPartNumber')
                                        }}><span>Manufacturer Part <br />Number</span></th>
                                    {isCoreUser && <th className={
                                        getOrderByClass('customerPartNumber') + ' minw140'
                                    }
                                        onClick={() => {
                                            sortAttributes('customerPartNumber')
                                        }}><span>Customer Part <br />Number</span></th>}
                                    <th className={
                                        getOrderByClass('orderStatus')
                                    }
                                        onClick={() => {
                                            sortAttributes('orderStatus')
                                        }}><span>Line status</span></th>
                                    <th className={
                                        getOrderByClass('quantity')
                                    }
                                        onClick={() => {
                                            sortAttributes('quantity')
                                        }}><span>Ordered <br />Quantity</span></th>
                                    <th className={
                                        getOrderByClass('unitPrice')
                                    }
                                        onClick={() => {
                                            sortAttributes('unitPrice')
                                        }}><span>Unit Price</span></th>
                                    <th className={
                                        getOrderByClass('totalLinePrice')
                                    }
                                        onClick={() => {
                                            sortAttributes('totalLinePrice')
                                        }}><span>Total Price</span></th>
                                    <th className={
                                        getOrderByClass('totalWithTax')
                                    }
                                        onClick={() => {
                                            sortAttributes('totalWithTax')
                                        }}><span>Total Price <br />With Tax</span></th>
                                    <th className={
                                        getOrderByClass('totalShippedQty')
                                    }
                                        onClick={() => {
                                            sortAttributes('totalShippedQty')
                                        }}><span>Total Shipped <br />Quantity</span></th>
                                    <th className={
                                        getOrderByClass('totalRemainingQty')
                                    }
                                        onClick={() => {
                                            sortAttributes('totalRemainingQty')
                                        }}><span>Total Remaining <br />Quantity</span></th>
                                    {isCoreUser && <th className={
                                        getOrderByClass('scheduleDate')
                                    }
                                        onClick={() => {
                                            sortAttributes('scheduleDate')
                                        }}><span>Customer <br />Requested Date</span></th>}
                                    <th className={
                                        getOrderByClass('deliveryDate')
                                    }
                                        onClick={() => {
                                            sortAttributes('deliveryDate')
                                        }}><span>Expected <br />Delivery Date</span></th>
                                    <th><span>Release Number</span></th>
                                    <th><span>Tracking Number</span></th>
                                    <th><span>Invoice Number</span></th>
                                    <th className={
                                        getOrderByClass('nCNR')
                                    }
                                        onClick={() => {
                                            sortAttributes('nCNR')
                                        }}><span>Information</span></th>
                                </tr>
                            </thead>
                            {sortedData?.map((j, i) => (
                                <tbody key={i}>
                                    <tr className={`align-middle ${expandedRow && expandedRow === j.itemNo ? 'bg-offwhite' : ''} ${((isReorderable && !j.isReOrder) || (isCancellable && !j.isCancel)) && 'disabled'}`} key={i}>
                                        <td>
                                            <div className="accordian-arrow">
                                                <i
                                                    className={expandedRow === j.itemNo ? 'fa fa-angle-double-up me-0 d-block' : 'fa fa-angle-double-down me-0 d-block'}

                                                    onClick={() => handleClick(j.itemNo)}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            {(isReorderable || isCancellable) &&
                                                <div className="form-check d-flex align-items-center font-15 ps-0">
                                                    <input type="checkbox" className="form-check-input ms-0"
                                                        id="forCheckbox"
                                                        onChange={() => (onToggleSelect(j))}
                                                        checked={getStatusOfForFieldActivated(j)}
                                                        disabled={(isReorderable && !j.isReOrder) || (isCancellable && !j.isCancel)}
                                                    />
                                                    <label className="form-check-label" htmlFor="forCheckbox" />
                                                </div>
                                            }
                                        </td>
                                        {isCoreUser && <td>
                                            <div>
                                                <a href={void (0)} className="text-blue2 d-flex align-items-center"
                                                    onClick={() => System.popup('OrderHistoryEmailPopUp', {
                                                        singleOrder: order_detail,
                                                        singleProduct: j
                                                    })}>
                                                    <i className="fa fa-envelope font-16"></i>
                                                </a>
                                            </div>
                                        </td>}
                                        <td>
                                            <div>{j.itemNo}</div>
                                        </td>
                                        <td><div>{j.manufacturerName}</div></td>
                                        <td>
                                            {j?.orderItemNumber && j.manufacturerPartNumber ?
                                                <NavigateToProductDetail target="_blank" data={{ SEOManufacturerName: j?.seoManufacturerName, SEOERPMFRPartNumber: j?.seoerpmfrPartNumber, ItemNumber: j?.orderItemNumber, ERPPartNumber: j?.sapMaterialNo }}>
                                                    <span className="text-nowrap text-blue2">{j.manufacturerPartNumber ? j.manufacturerPartNumber : ''}</span>
                                                </NavigateToProductDetail> :
                                                <span className="text-nowrap">{j.manufacturerPartNumber ? j.manufacturerPartNumber : ''}</span>
                                            }
                                            <p className='mb-0'>{j.manufacturerPartDesc ? j.manufacturerPartDesc : ''}</p>
                                        </td>
                                        {isCoreUser && <td><span className="text-nowrap">{j.customerPartNumber && j.customerPartNumber}</span></td>}
                                        <td><span className="text-nowrap">{j.orderStatus && j.orderStatus}</span></td>
                                        <td><span className="text-nowrap">{j.quantity && get_quantity_format(Number(j.quantity))}</span></td>
                                        <td><span className="text-nowrap">{j.unitPrice && System.getFormatNumber({ amount: Number(j.unitPrice), currency: USD })}</span></td>
                                        <td><span className="text-nowrap">{j.totalLinePrice && System.getFormatNumber({ amount: Number(j.totalLinePrice), currency: USD,maximumFractionDigits: 2 })}</span></td>
                                        <td><span className="text-nowrap">{j.totalWithTax && System.getFormatNumber({ amount: Number(j.totalWithTax), currency: USD })}</span></td>
                                        <td><span className="text-nowrap">{j.totalShippedQty && get_quantity_format(Number(j.totalShippedQty))}</span></td>
                                        <td><span className="text-nowrap">{j.totalRemainingQty && get_quantity_format(Number(j.totalRemainingQty))}</span></td>
                                        {isCoreUser && <td><span className="text-nowrap">{j.scheduleDate && Helper.convertOrderModuleDateFormat(j.scheduleDate)}</span></td>}
                                        <td><span className="text-nowrap">{j.deliveryDate && Helper.convertOrderModuleDateFormat(j.deliveryDate)}</span></td>
                                        <td><span className="text-nowrap">{j?.deliveryNos ? j?.deliveryNos?.length > 2 ?
                                            <a onClick={() => System.popup('OrderReleasesPopup', { releaseNo: j.deliveryNos, poNumber: order_detail?.poNumber })}>View all Releases</a> :
                                            j.deliveryNos.map((value, index) => (
                                                <div key={index}>{value}</div>
                                            )) : ''}</span>
                                        </td>
                                        <td>
                                            <span className="text-nowrap">{j?.trackingDetails ? j?.trackingDetails?.length > 2 ?
                                                <a onClick={() => System.popup('OrderDetailViewAllTrackingPopup', { trackingDetails: j.trackingDetails, poNumber: order_detail?.poNumber })}>View all Tracking</a> :
                                                j.trackingDetails.map((value, index) => (
                                                    <div key={index}>
                                                        {value.trackingUrl ?
                                                            <a href={value.trackingUrl} target='_blank'><span className='text-blue'>{value?.trackingNo}</span></a> :
                                                            <span className='text-black'>{value?.trackingNo}</span>}
                                                    </div>
                                                )) : ''}
                                            </span>
                                        </td>
                                        <td><span className="text-nowrap text-blue2 cursor-pointer">{j?.invoiceNos ? j?.invoiceNos?.length > 2 ?
                                            <a onClick={() => {
                                                System.popup('OrderDetailViewInvoicesPopup', {
                                                    invoiceData: j?.invoiceNos,
                                                    poNumber: order_detail.poNumber
                                                })
                                            }}>View all Invoices</a> :
                                            j.invoiceNos.map((value, index) => (
                                                <div key={index} className="mb-2">
                                                    <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                        onClick={() => downloadInvoice([value])}>{value} </a>
                                                    <input type="hidden" id="invoiceUrlGeneration1" />
                                                </div>
                                            )) : ''}</span>
                                        </td>
                                        <td><span className="text-nowrap">{j.nCNR ? renderLegendIcon(noncancel, 'Non-Cancelable, Non-Returnable', false) : ""}</span></td>
                                    </tr>
                                    <tr className='align-middle bg-offwhite'>
                                        <td colSpan={19} className='p-0'>
                                            <div className={expandedRow === j.itemNo ? "table-responsive mb-0" : "table-responsive mb-0 d-none"}>
                                                <table className="bs5 table table-head-border-x-0 mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th className="w40 border-0 bg-offwhite"></th>
                                                            <th className="w40 border-0 bg-offwhite"></th>
                                                            <th className="w40 border-0 bg-offwhite"></th>
                                                            <th className="w150"><span>Shipped Quantity</span></th>
                                                            <th className="w150"><span>Shipped on Date</span></th>
                                                            {isCoreUser && <th className="w150"><span>Customer <br />Requested Date</span></th>}
                                                            <th className="w150"><span>Expected <br />Delivery Date</span></th>
                                                            <th className="w150"><span>Release Number</span></th>
                                                            <th className="w150"><span>Tracking Number</span></th>
                                                            <th className=""><span>Invoice Number</span></th>
                                                        </tr>
                                                    </thead>
                                                    {j.schedules?.length > 0 &&
                                                        <>
                                                            <tbody>
                                                                {j.schedules?.map((val, i) => (
                                                                    <tr className="align-middle" key={i}>
                                                                        <td className='border-0'></td>
                                                                        <td className='border-0'></td>
                                                                        <td className='border-0'></td>
                                                                        <td><div>{get_quantity_format(Number(val.shippedQty))}</div></td>
                                                                        <td><div>{val.shippedDate ? Helper.convertOrderModuleDateFormat(val.shippedDate) : ""}</div></td>
                                                                        {isCoreUser && <td><div>{val.scheduleDate ? Helper.convertOrderModuleDateFormat(val.scheduleDate) : ""}</div></td>}
                                                                        <td><div>{val.deliveryDate ? Helper.convertOrderModuleDateFormat(val.deliveryDate) : ""}</div></td>
                                                                        <td>{val?.deliveryNos ? val?.deliveryNos?.length > 2 ?
                                                                            <a onClick={() => System.popup('OrderReleasesPopup', { releaseNo: val.deliveryNos, poNumber: order_detail?.poNumber })}>View all Releases</a> :
                                                                            val.deliveryNos.map((value, index) => (
                                                                                <div key={index}>{value}</div>
                                                                            )) : ''}
                                                                        </td>
                                                                        <td>
                                                                            {val?.trackingDetails ? val?.trackingDetails?.length > 2 ?
                                                                                <a onClick={() => System.popup('OrderDetailViewAllTrackingPopup', { trackingDetails: val.trackingDetails, poNumber: order_detail?.poNumber })}>View all Tracking</a> :
                                                                                val.trackingDetails.map((value, index) => (
                                                                                    <div key={index}>
                                                                                        {value.trackingUrl ?
                                                                                            <a href={value.trackingUrl} target='_blank'><span className='text-blue'>{value?.trackingNo}</span></a> :
                                                                                            <span className='text-black'>{value?.trackingNo}</span>}
                                                                                    </div>
                                                                                )) : ''}
                                                                        </td>
                                                                        <td className='text-blue2 cursor-pointer'>{val?.invoiceNos ? val?.invoiceNos?.length > 2 ?
                                                                            <a onClick={() => {
                                                                                System.popup('OrderDetailViewInvoicesPopup', {
                                                                                    invoiceData: val?.invoiceNos,
                                                                                    poNumber: order_detail.poNumber
                                                                                })
                                                                            }}>View all Invoices</a> :
                                                                            val.invoiceNos.map((value, index) => (
                                                                                <div key={index} className="mb-2">
                                                                                    <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                                                        onClick={() => downloadInvoice([value])}>{value} </a>
                                                                                    <input type="hidden" id="invoiceUrlGeneration1" />
                                                                                </div>
                                                                            )) : ''}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </>}
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ))}
                        </table>
                    }
                </div>
            </div>
        </>
    )
}

export default OrderDetailByLineItem